// @flow

import React from 'react';
import NavLink from 'hoc/portalPath/NavLink';
import toUIAddress from '@active/awe-ui-core/lib/dataTransfer/address';
import AddressStatic from 'react-aaui/lib/form/AddressStatic';
import DateCard from 'components/DateCard/DateCard';
import './Event.scss';

type Props = {
  name: string,
  startDate: string,
  address: Object,
  locale: string,
  timeZone: string,
  category: string,
  applicationName: string,
  isVirtual: Boolean
}

const Event = ({
  name, startDate, address, locale, timeZone, category, applicationName, isVirtual,
}: Props) => {
  const uiAddress = toUIAddress(address);
  return (
    <div>
      <DateCard date={startDate} timeZone={timeZone} locale={locale} />
      <div className="recent-events-event-info">
        <div className="recent-events-event-info__link">
          <NavLink to={`/events/${applicationName}`}>
            {name}
          </NavLink>
        </div>
        <div className="recent-events-event-info__address">{ !isVirtual && <AddressStatic address={uiAddress} nowrap locale={locale} /> }</div>
        <div className="recent-events-event-info__category">{category}</div>
      </div>
    </div>
  );
};

export default Event;
